module.exports = __webpack_public_path__ + "img/5.bf82326c.jpg";